<template>
  <ModalDefault modal_id="addTemplateModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_641')"
                :footer="templates.step !== 3"
                icon="bx bx-copy-alt mr-1">
    <div @click.prevent="isShowEmoji = null;" class="px-2 py-0" slot="body">
      <div v-if="templates.step === 2" class="row pt-2">
        <div class="col-12 px-3 pt-3">
          <div class="alert alert-warning rounded-0">
            {{ getTranslations('expression_642') }}
          </div>
        </div>
      </div>

      <!-- STEP 1-->
      <div v-if="templates.step === 1" class="row px-2 pt-1">
        <div class="col-md-12">
          <label class="mb-0">
            Nome do template
            <span class="text-danger"
                  v-b-tooltip.bottom
                  :title="getTranslations('expression_643')">*</span>
          </label>
          <div class="input-group mb-3">
            <input type="text" v-model="templates.new.name" class="input_forms form-control">
          </div>
          <small>
            <i class="fas fa-exclamation-triangle fa-1x text-warning pr-2"></i>
            {{ getTranslations('expression_644') }}
          </small>
        </div>
        <div class="col-md-6">
          <label class="mb-0">
            {{ getTranslations('expression_645') }}
            <span class="text-danger"
                  v-b-tooltip.bottom
                  :title="getTranslations('expression_643')">*</span>
          </label>
          <div class="input-group mb-4">
            <select v-model="templates.new.category"
                    v-if="configs.data.channel_hsm && configs.data.channel_hsm.categories"
                    class="input_forms custom-select px-50">
              <option :value="null" selected>{{ getTranslations('expression_646') }}</option>
              <option v-for="(category, index) in configs.data.channel_hsm.categories"
                      :key="index"
                      :value="category.value">
                {{ category.label }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-6">
          <label class="mb-0">
            {{ getTranslations('expression_647') }}
            <span class="text-danger"
                  v-b-tooltip.bottom
                  :title="getTranslations('expression_643')">*</span>
          </label>
          <div class="input-group mb-4">
            <select v-model="templates.new.language"
                    v-if="configs.data.channel_hsm && configs.data.channel_hsm.languages"
                    class="input_forms custom-select px-50">
              <option :value="null" selected>{{ getTranslations('expression_648') }}</option>
              <option v-for="(lang, index) in configs.data.channel_hsm.languages"
                      :key="index"
                      :value="lang">
                {{ lang }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div v-if="templates.step === 1" class="row px-2">
        <div class="col-md-12 pt-0">
          <label class="mb-0">{{ getTranslations('expression_649') }}</label>
          <div class="pt-3 d-flex">
            <div class="pr-2">
              <div @click.prevent="templates.new.options.header = !templates.new.options.header"
                   :class="templates.new.options.header ? 'btn-primary' : 'btn-outline-primary'"
                   class="rounded-0 px-3 btn-sm btn">
                <i :class="templates.new.options.header ? 'bx-check' : 'bx-x'" class="bx"></i>
                {{ getTranslations('expression_650') }}
              </div>
            </div>
            <div class="pr-2">
              <div v-b-tooltip.bottom
                   :title="getTranslations('expression_643')"
                   class="rounded-0 px-3 btn-sm btn btn-primary">
                <i class="bx bx-check"></i> {{ getTranslations('expression_651') }}
              </div>
            </div>
            <div class="pr-2">
              <div @click.prevent="templates.new.options.footer = !templates.new.options.footer"
                   :class="templates.new.options.footer ? 'btn-primary' : 'btn-outline-primary'"
                   class="rounded-0 px-3 btn-sm btn">
                <i :class="templates.new.options.footer ? 'bx-check' : 'bx-x'" class="bx"></i>
                {{ getTranslations('expression_652') }}
              </div>
            </div>
            <div class="pr-2">
              <div @click.prevent="templates.new.options.buttons = !templates.new.options.buttons"
                   :class="templates.new.options.buttons ? 'btn-primary' : 'btn-outline-primary'"
                   class="rounded-0 px-3 btn-sm btn">
                <i :class="templates.new.options.buttons ? 'bx-check' : 'bx-x'" class="bx"></i>
                {{ getTranslations('expression_653') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- HEADER-->
      <div v-if="templates.step === 1 && templates.new.options.header" class="row px-2 pb-1 animated--grow-in">
        <div class="col-md-12 pt-4">
          <div class="card border">
            <div class="card-header d-flex justify-content-between" style="align-items: center;">
              <div class="title-color d-flex" style="font-family: 'Product Sans Medium Regular'; font-size: 1rem;">
                <span class="cursor_default ml-0 pl-0 ellipsis title-color"> {{
                    getTranslations('expression_650')
                  }}</span>
              </div>
              <div>
                <div class="input-group">
                  <select v-model="templates.new.header.format"
                          v-if="configs.data.channel_hsm.header.types"
                          @change.prevent="clear()"
                          class="input_forms border custom-select pl-3">
                    <option :value="null" disabled>{{ getTranslations('expression_646') }}</option>
                    <option v-for="(header, index) in configs.data.channel_hsm.header.types"
                            :key="index"
                            :value="header.value">
                      {{ header.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <!-- TEXT -->
                  <div v-if="templates.new.header.format === 'TEXT'">
                    <textarea class="w-100"
                              maxlength="60"
                              v-model="templates.new.header.content"
                              ref="input_1"
                              :placeholder="getTranslations('expression_654')"></textarea>
                    <div class="text-right"
                         style="margin-top: -25px;
                          margin-bottom: 0;
                          position: relative;
                          width: 60px;
                          float: right;
                          z-index: 9;">
                      <i v-b-tooltip.right
                         :title="getTranslations('expression_298')"
                         @click.stop="showEmoji(1)"
                         class="animated--grow-in bx bx-happy hover_icons cursor_pointer mr-3"
                         style="font-size: 1.2rem;"></i>
                    </div>
                    <div class="px-0 pb-2"
                         style="margin-top: 20px; position: absolute; z-index: 99999; min-width: 95%;">
                      <div @click.stop="">
                        <VEmojiPicker v-if="isShowEmoji === 1"
                                      @select="selectEmoji"
                                      :emojiWithBorder="false"
                                      :emojisByRow="12"
                                      :showSearch="false"
                                      :i18n="i18n"
                                      :limitFrequently="14"
                                      style="width: 100%;"
                                      class="custom-picker-emoji shadow animated--fade-in"/>
                      </div>
                    </div>
                  </div>
                  <!-- FILE -->
                  <div v-else @click.stop="" class="col-12 cursor_pointer d-flex pb-2 pt-3 px-2">
                    <!-- CAMPOS VAZIOS -->
                    <div style="width: 100%;
                                min-height: 250px;
                                display: flex;
                                align-items: center;
                                background-color: #f8fafb;
                                justify-content: center;"
                         @click.stop="uploadFileHSM"
                         class="cursor_pointer shadow-sm"
                         v-if="templates.new.header.format === 'IMAGE' && templates.new.header_file.file === null">
                      <i class="bx bx-photo-album text-gray-600" style="font-size: 85px;"></i>
                    </div>
                    <div style="width: 100%;
                                min-height: 250px;
                                display: flex;
                                align-items: center;
                                background-color: #f8fafb;
                                justify-content: center;"
                         @click.stop="uploadFileHSM"
                         class="cursor_pointer shadow-sm"
                         v-if="templates.new.header.format === 'VIDEO' && templates.new.header_file.file === null">
                      <i class="bx bx-camera-movie text-gray-600" style="font-size: 85px;"></i>
                    </div>
                    <div style="width: 100%;
                                min-height: 250px;
                                display: flex;
                                align-items: center;
                                background-color: #f8fafb;
                                justify-content: center;"
                         @click.stop="uploadFileHSM"
                         class="cursor_pointer shadow-sm"
                         v-if="templates.new.header.format === 'DOCUMENT' && templates.new.header_file.file === null">
                      <i class="bx bxs-file-pdf text-gray-600" style="font-size: 85px;"></i>
                    </div>

                    <!-- PREVIEW -->
                    <div class="border cursor_pointer shadow-sm"
                         @click.stop="uploadFileHSM"
                         v-if="templates.new.header_file.file && ['image/png', 'image/jpeg', 'image/jpg'].includes(templates.new.header_file.mimetype)"
                         :style="`background-image: url(${templates.new.header_file.file})`"
                         style="width: 100%;
                                min-height: 250px;
                                background-position: center;
                                background-size: cover;
                                background-repeat: no-repeat;">
                    </div>
                    <div style="width: 100%;
                                min-height: 250px;
                                display: flex;
                                align-items: center;
                                background-color: #f8fafb;
                                justify-content: center;"
                         @click.stop="uploadFileHSM"
                         class="cursor_pointer shadow-sm"
                         v-if="['application/pdf'].includes(templates.new.header_file.mimetype)">
                      <div class="row">
                        <div class="col-12 text-center">
                          <i class="bx bxs-file-pdf text-success" style="font-size: 85px;"></i>
                          <div>{{ templates.new.header_file.filename }}</div>
                        </div>
                      </div>
                    </div>
                    <div style="width: 100%;
                                min-height: 250px;
                                display: flex;
                                align-items: center;
                                background-color: #f8fafb;
                                justify-content: center;"
                         @click.stop="uploadFileHSM"
                         class="cursor_pointer shadow-sm"
                         v-if="['video/mpeg', 'video/mp4'].includes(templates.new.header_file.mimetype)">
                      <i class="bx bx-camera-movie text-success" style="font-size: 85px;"></i>
                    </div>
                    <!-- Botão de remover-->
                    <div v-if="templates.new.header_file.file !== null">
                      <div class="pt-3" style="margin-left: -55px;">
                        <i v-b-tooltip.bottom
                           :title="getTranslations('expression_297')"
                           @click.stop="removeFileHSM"
                           class="bg-white text-secondary shadow-sm rounded-circle py-1 px-1 bx bx-x bx-xs cursor_pointer"></i>
                      </div>
                    </div>
                    <!-- Input file-->
                    <input type="file"
                           @change="loadFileHSM()"
                           id="fileHandlerHSM"
                           multiple="multiple" hidden>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="templates.new.header.format === 'TEXT'"
                 class="card-footer">
              <div class="row">
                <div class="col-12 text-right">
                  <small :class="templates.new.header.content.length > 55 ? 'badge-danger' : 'badge-secondary'"
                         class="badge font-weight-light rounded-0">
                    {{ templates.new.header.content.length }} / 60 {{ getTranslations('expression_655') }}
                  </small>
                  <small :class="variable_header > 0 ? 'badge-danger' : 'badge-secondary'"
                         class="badge font-weight-light rounded-0">{{ variable_header }} / 1
                    {{ getTranslations('expression_656') }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- BODY-->
      <div v-if="templates.step === 1" class="row px-2 pb-1">
        <div class="col-md-12 pt-4">
          <div class="card border">
            <div class="card-header d-flex justify-content-between" style="align-items: center;">
              <div class="title-color d-flex" style="font-family: 'Product Sans Medium Regular'; font-size: 1rem;">
                <span class="cursor_default ml-0 pl-0 ellipsis title-color">
                  {{ getTranslations('expression_651') }}
                  <span class="text-danger"
                        v-b-tooltip.bottom
                        :title="getTranslations('expression_643')">*</span>
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea maxlength="1024"
                            v-model="templates.new.body.text"
                            class="w-100"
                            ref="input_2"
                            :placeholder="getTranslations('expression_657')"></textarea>
                  <div class="text-right"
                       style="margin-top: -25px;
                          margin-bottom: 0;
                          position: relative;
                          width: 60px;
                          float: right;
                          z-index: 9;">
                    <i v-b-tooltip.right
                       :title="getTranslations('expression_298')"
                       @click.stop="showEmoji(2)"
                       class="animated--grow-in bx bx-happy hover_icons cursor_pointer mr-3"
                       style="font-size: 1.2rem;"></i>
                  </div>
                  <div class="px-0 pb-2" style="margin-top: 20px; position: absolute; z-index: 99999; min-width: 95%;">
                    <div @click.stop="">
                      <VEmojiPicker v-if="isShowEmoji === 2"
                                    @select="selectEmoji"
                                    :emojiWithBorder="false"
                                    :emojisByRow="12"
                                    :showSearch="false"
                                    :i18n="i18n"
                                    :limitFrequently="14"
                                    style="width: 100%;"
                                    class="custom-picker-emoji shadow animated--fade-in"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-12 text-right">
                  <small :class="templates.new.body.text.length > 1014 ? 'badge-danger' : 'badge-secondary'"
                         class="badge font-weight-light rounded-0">{{ templates.new.body.text.length }} / 1024
                    {{ getTranslations('expression_655') }}</small>
                  <small :class="variable_body > 3 ? 'badge-danger' : 'badge-secondary'"
                         class="badge font-weight-light rounded-0">{{ variable_body }} / 4
                    {{ getTranslations('expression_547').toLowerCase() }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- FOOTER -->
      <div v-if="templates.step === 1 && templates.new.options.footer" class="row px-2 pb-1 animated--grow-in">
        <div class="col-md-12 pt-4">
          <div class="card border">
            <div class="card-header d-flex justify-content-between" style="align-items: center;">
              <div class="title-color d-flex" style="font-family: 'Product Sans Medium Regular'; font-size: 1rem;">
                <span class="cursor_default ml-0 pl-0 ellipsis title-color"> {{
                    getTranslations('expression_652')
                  }}</span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-12">
                  <textarea class="w-100"
                            maxlength="60"
                            ref="input_3"
                            v-model="templates.new.footer.text"
                            :placeholder="getTranslations('expression_658')"></textarea>
                  <div class="text-right"
                       style="margin-top: -25px;
                          margin-bottom: 0;
                          position: relative;
                          width: 60px;
                          float: right;
                          z-index: 9;">
                    <i v-b-tooltip.right
                       :title="getTranslations('expression_298')"
                       @click.stop="showEmoji(3)"
                       class="animated--grow-in bx bx-happy hover_icons cursor_pointer mr-3"
                       style="font-size: 1.2rem;"></i>
                  </div>
                  <div class="px-0 pb-2" style="margin-top: 20px; position: absolute; z-index: 99999; min-width: 95%;">
                    <div @click.stop="">
                      <VEmojiPicker v-if="isShowEmoji === 3"
                                    @select="selectEmoji"
                                    :emojiWithBorder="false"
                                    :emojisByRow="12"
                                    :showSearch="false"
                                    :i18n="i18n"
                                    :limitFrequently="14"
                                    style="width: 100%;"
                                    class="custom-picker-emoji shadow animated--fade-in"/>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-12 text-right">
                  <small :class="templates.new.footer.text.length > 55 ? 'badge-danger' : 'badge-secondary'"
                         class="badge font-weight-light rounded-0">{{ templates.new.footer.text.length }} / 60
                    {{ getTranslations('expression_655') }}</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- BUTTONS -->
      <div v-if="templates.step === 1 && templates.new.options.buttons" class="row px-2 pb-1 animated--grow-in">
        <div class="col-md-12 pt-4">
          <div class="card border">
            <div class="card-header d-flex justify-content-between" style="align-items: center;">
              <div class="title-color d-flex" style="font-family: 'Product Sans Medium Regular'; font-size: 1rem;">
                <span class="cursor_default ml-0 pl-0 ellipsis title-color">
                  {{ getTranslations('expression_653') }}
                </span>
              </div>
              <div class="d-flex">
                <div v-if="button_validate" class="pr-2 pt-1">
                  <div class="btn btn-sm btn-secondary rounded-0"
                       @click.prevent="addButton(type_button)"
                       style="width: 130px;"> {{ getTranslations('expression_659') }}
                  </div>
                </div>
                <div class="input-group">
                  <select v-model="type_button"
                          :disabled="templates.new.buttons.length > 0"
                          v-if="configs.data.channel_hsm && configs.data.channel_hsm.button.types"
                          class="input_forms border custom-select pl-3 pr-4">
                    <option :value="null" selected>{{ getTranslations('expression_596') }}</option>
                    <option v-for="(button, index) in configs.data.channel_hsm.button.types"
                            :key="index"
                            :value="index">
                      {{ button.label }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div v-if="templates.new.buttons.length > 0" class="row">
                <div v-for="(button, index) in templates.new.buttons"
                     :key="index"
                     class="col-12">
                  <div class="card border">
                    <div class="card-header d-flex justify-content-between" style="align-items: center;">
                      <div class="d-flex" style="align-items: center;">
                        <div class="title-color pr-3 d-flex"
                             style="font-family: 'Product Sans Medium Regular'; font-size: 1rem;">
                          <span class="cursor_default ml-0 pl-0 ellipsis title-color"> {{
                              getTranslations('expression_660')
                            }}</span>
                        </div>
                        <div>
                          <!-- QUICK_REPLY-->
                          <div v-if="templates.new.buttons[index].type === 'QUICK_REPLY'" class="input-group">
                            <select :disabled="templates.new.buttons[index].type === 'QUICK_REPLY'"
                                    class="input_forms border custom-select pl-3 pr-4">
                              <option :value="null">{{ getTranslations('expression_596') }}</option>
                              <option selected>{{ getTranslations('expression_661') }}</option>
                            </select>
                          </div>
                          <!-- CTA-->
                          <div v-else class="input-group">
                            <select v-model="templates.new.buttons[index].type"
                                    :disabled="templates.new.buttons.length > 1"
                                    @change.prevent="changeButtonType(index)"
                                    class="input_forms border custom-select pl-3 pr-4">
                              <option :value="null" selected>{{ getTranslations('expression_596') }}</option>
                              <option v-for="(button, index) in configs.data.channel_hsm.button.types[0].types"
                                      :key="index"
                                      :value="button.value">
                                {{ button.label }}
                              </option>
                            </select>
                          </div>

                        </div>
                      </div>
                      <div class="cursor_pointer">
                        <i @click.prevent="removeButton(index)" class="bx bx-trash"></i>
                      </div>
                    </div>
                    <div class="card-body">
                      <!-- QUICK_REPLY-->
                      <div v-if="templates.new.buttons[index].type === 'QUICK_REPLY'">
                        <textarea maxlength="20"
                                  v-model="templates.new.buttons[index].text"
                                  class="w-100"
                                  :placeholder="getTranslations('expression_662')"></textarea>
                      </div>
                      <!-- CTA - PHONE-->
                      <div v-if="templates.new.buttons[index].type === 'PHONE_NUMBER'">
                        <input type="text" maxlength="20"
                               v-model="templates.new.buttons[index].text"
                               class="w-100"
                               :placeholder="getTranslations('expression_663')">
                        <hr>
                        <input type="text"
                               v-model="templates.new.buttons[index].phone_number"
                               class="w-100"
                               :placeholder="getTranslations('expression_664')">
                      </div>
                      <!-- CTA - URL-->
                      <div v-if="templates.new.buttons[index].type === 'URL'">
                        <input type="text" maxlength="20"
                               v-model="templates.new.buttons[index].text"
                               class="w-100"
                               :placeholder="getTranslations('expression_665')">
                        <hr>
                        <input type="text"
                               @keyup.prevent="whatIsTheIndex(index)"
                               v-model="templates.new.buttons[index].url"
                               class="w-100"
                               :placeholder="getTranslations('expression_666')">
                      </div>
                    </div>
                    <div class="card-footer">
                      <div class="row">
                        <div class="col-12 text-right">
                          <small v-if="templates.new.buttons[index].type === 'QUICK_REPLY'"
                                 :class="templates.new.buttons[index].text.length === 20 ? 'badge-danger' : 'badge-secondary'"
                                 class="badge font-weight-light rounded-0">
                            {{ templates.new.buttons[index].text.length }} / 20 {{ getTranslations('expression_655') }}
                          </small>
                          <small v-if="templates.new.buttons[index].type === 'PHONE_NUMBER'"
                                 :class="templates.new.buttons[index].text.length === 20 ? 'badge-danger' : 'badge-secondary'"
                                 class="badge font-weight-light rounded-0">
                            {{ templates.new.buttons[index].text.length }} / 20 {{ getTranslations('expression_655') }}
                          </small>
                          <small v-if="templates.new.buttons[index].type === 'URL'"
                                 :class="templates.new.buttons[index].text.length === 20 ? 'badge-danger' : 'badge-secondary'"
                                 class="badge font-weight-light rounded-0">
                            {{ templates.new.buttons[index].text.length }} / 20 {{ getTranslations('expression_655') }}
                          </small>
                          <small v-if="templates.new.buttons[index].type === 'URL'"
                                 :class="variable_button_url === 1 ? 'badge-danger' : 'badge-secondary'"
                                 class="badge font-weight-light rounded-0">
                            {{ variable_button_url }} / 1 {{ getTranslations('expression_656') }}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-else class="row">
                <div class="col-12 text-center">
                  <div class="pt-4 pb-3">
                    <h6>{{ getTranslations('expression_667') }}</h6>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-12 text-right">
                  <small v-if="type_button > 0"
                         :class="templates.new.buttons.length === 3 ? 'badge-danger' : 'badge-secondary'"
                         class="badge font-weight-light rounded-0">
                    {{ templates.new.buttons.length }} / 3 {{ getTranslations('expression_653').toLowerCase() }}
                  </small>
                  <small v-else
                         :class="templates.new.buttons.length === 2 ? 'badge-danger' : 'badge-secondary'"
                         class="badge font-weight-light rounded-0">
                    {{ templates.new.buttons.length }} / 2 {{ getTranslations('expression_653').toLowerCase() }}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Space-->
      <div v-if="templates.step === 1" class="row">
        <div class="col-12">
        </div>
      </div>

      <!-- STEP 2-->
      <div v-if="templates.step === 2" class="row px-2">
        <div class="col-md-6">
          <div class="row">
            <div class="col-12">
              <i class="bx bxs-badge-check pr-2"></i> {{ getTranslations('expression_668') }}
            </div>
            <div class="col-12 px-3" v-if="variable_header === 0 && variable_body === 0">
              <div class="col-12 alert alert-danger rounded-0">
                {{ getTranslations('expression_669') }}
              </div>
            </div>
            <div class="col-12 px-3" v-if="variable_header > 0">
              <label class="mb-0">{{ getTranslations('expression_650') }} - {{ getTranslations('expression_656') }}
                {<span>{</span>1}}</label>
              <div class="input-group mb-2">
                <input type="text"
                       class="input_forms px-50 form-control" v-model="templates.new.header.examples[0]">
              </div>
            </div>
            <div class="col-12 px-3" v-for="(variable, index) in variable_body" :key="`body${index}`">
              <label class="mb-0">{{ getTranslations('expression_651') }} - {{ getTranslations('expression_656') }}
                {<span>{</span>{{ index + 1 }}}}</label>
              <div class="input-group mb-2">
                <input type="text" :disabled="index > 0 && !templates.new.body.examples[index-1]"
                       class="input_forms px-50 form-control"
                       v-model="templates.new.body.examples[index]">
              </div>
            </div>
            <div class="col-12 px-3" v-for="(variable, index) in variable_button_url" :key="variable">
              <label class="mb-0">{{ getTranslations('expression_670') }} - {{ getTranslations('expression_656') }}
                {<span>{</span>{{ index + 1 }}}}</label>
              <div class="input-group mb-2">
                <input type="text" :disabled="index > 0 && !templates.new.buttons[index_button_url].example[index-1]"
                       class="input_forms px-50 form-control" v-model="variable_button_url_var">
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row px-2" style="position: sticky; top: 5px;">
            <div class="col-12">
              <i class="bx bxs-show pr-2"></i> {{ getTranslations('expression_671') }}
            </div>
            <div class="col-12" style="min-height: 400px;">
              <div class="px-3 py-3 bg-white shadow-sm">
                <div class="row">

                  <div v-if="templates.new.header_file.file !== null" class="col-12 pb-0 pt-3 px-3">
                    <div class="border shadow-sm"
                         v-if="templates.new.header_file.file && ['image/png', 'image/jpeg', 'image/jpg'].includes(templates.new.header_file.mimetype)"
                         :style="`background-image: url(${templates.new.header_file.file})`"
                         style="width: 100%;
                                min-height: 200px;
                                background-position: center;
                                background-size: cover;
                                background-repeat: no-repeat;">
                    </div>
                    <div style="width: 100%;
                                min-height: 200px;
                                display: flex;
                                align-items: center;
                                background-color: #f8fafb;
                                justify-content: center;"
                         class="cursor_default shadow-sm"
                         v-if="['application/pdf'].includes(templates.new.header_file.mimetype)">
                      <i class="bx bxs-file-pdf text-gray-600" style="font-size: 65px;"></i>
                    </div>
                    <div style="width: 100%;
                                min-height: 200px;
                                display: flex;
                                align-items: center;
                                background-color: #f8fafb;
                                justify-content: center;"
                         class="cursor_default shadow-sm"
                         v-if="['video/mpeg', 'video/mp4'].includes(templates.new.header_file.mimetype)">
                      <i class="bx bx-camera-movie text-gray-600" style="font-size: 65px;"></i>
                    </div>
                  </div>
                  <!--HEADER-->
                  <div v-if="templates.new.header.content" class="col-12 pt-3 pb-1 px-3">
                    <span style="overflow:hidden;
                                word-wrap: break-word;
                                white-space: pre-wrap;"
                          :class="templates.new.header.content ? 'text-gray-800' : 'text-gray-500'"
                          v-html="templates.new.header.content ? preview_header : getTranslations('expression_672')">
                    </span>
                  </div>
                  <!--BODY-->
                  <div class="col-12 pt-3 pb-1 px-3">
                    <span style="overflow:hidden;
                                word-wrap: break-word;
                                white-space: pre-wrap;"
                          :class="templates.new.body.text ? 'text-gray-800' : 'text-gray-500'"
                          v-html="templates.new.body.text ? preview_body : getTranslations('expression_301')">
                    </span>
                  </div>
                  <!--FOOTER-->
                  <div v-if="templates.new.footer.text !== ''" class="col-12 pt-3 pb-1 px-3">
                    <small style="overflow:hidden;
                                word-wrap: break-word;
                                white-space: pre-wrap;"
                           :class="templates.new.footer.text ? 'text-gray-600' : 'text-gray-600'"
                           v-html="templates.new.footer.text ? templates.new.footer.text : getTranslations('expression_673')">
                    </small>
                  </div>
                  <div class="col-12 text-right text-gray-600 pt-1 px-3 pb-1"></div>
                </div>
              </div>
              <!--BUTTONS-->
              <div v-if="templates.new.buttons.length > 0" class="px-2 py-3">
                <div class="row px-1 pt-2">
                  <div v-for="(buttons, index) in templates.new.buttons"
                       :key="index"
                       class="col text-center bg-white border-bottom cursor_pointer shadow-sm">
                    {{ buttons.text }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- STEP 3-->
      <div v-if="templates.step === 3" class="row px-2 py-3">
        <div class="col-md-12 pt-5 pb-0 text-center animated--grow-in">
          <i class="bx bxs-check-circle text-success" style="font-size: 60px;"></i>
        </div>
        <div class="col-md-12 pb-0 text-center">
          <h4 class="title-color pb-0">{{ getTranslations('expression_674') }}</h4>
        </div>
        <div class="col-md-12 pt-0 pb-5 text-center">
          <small>
            {{ getTranslations('expression_675') }} <strong>{{ getTranslations('expression_676') }}</strong>
            {{ getTranslations('expression_677') }}
          </small>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div v-if="templates.step === 1">
        <div v-if="(templates.new.body.text && templates.new.body.text !== '') &&
                  (templates.new.name && templates.new.name !== '') &&
                  (templates.new.category) &&
                  (templates.new.language && templates.new.language !== '') ">
        <span @click.prevent="setStep(2)"
              class="shadow-sm cursor_pointer animated--grow-in btn-outline-primary py-2 px-3">
          <span class="">{{ getTranslations('expression_678') }}</span>
        </span>
        </div>
        <div v-else>
        <span style="cursor: not-allowed"
              class="shadow-sm cursor_pointer animated--grow-in btn-outline-danger py-2 px-3">
          <span class="">{{ getTranslations('expression_679') }}</span>
        </span>
        </div>
      </div>
      <div v-if="templates.step === 2" class="pr-2">
        <span @click.prevent="setStep(1);"
              class="shadow-sm cursor_pointer animated--grow-in btn-outline-secondary py-2 px-3">
          <span class="">{{ getTranslations('expression_113') }}</span>
        </span>
      </div>

      <div v-if="templates.step === 2 && validateVarsHeader && validateVarsBody && validateVarsButtons && validateFileHeader">
        <span @click.prevent="setStep(3); addTemplate()"
              data-dismiss="modal"
              class="shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
          <span class="">{{ getTranslations('expression_680') }}</span>
        </span>
      </div>


    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../general/ModalDefault";
import {mapGetters, mapState} from "vuex";
import $ from "jquery";
import no_pic from "../../assets/img/no-pic.png";
import Swal from "sweetalert2";

export default {
  name: "ModalAddTemplateHSM",
  components: {
    ModalDefault
  },
  computed: {
    ...mapState(['templates', 'channels', 'configs']),
    ...mapGetters([]),
    preview_header() {
      let text = this.templates.new.header.content.toString();
      if (this.templates.new.header.examples[0]) {
        text = text.replaceAll('{{1}}', this.templates.new.header.examples[0]);
      } else {
        text = this.templates.new.header.content.toString()
      }
      return text;
    },
    preview_body() {
      let text = this.templates.new.body.text.toString();
      if (this.templates.new.body.examples[0]) {
        text = text.replaceAll('{{1}}', this.templates.new.body.examples[0]);
        if (this.templates.new.body.examples[1]) {
          text = text.replaceAll('{{2}}', this.templates.new.body.examples[1]);
          if (this.templates.new.body.examples[2]) {
            text = text.replaceAll('{{3}}', this.templates.new.body.examples[2]);
            if (this.templates.new.body.examples[3]) {
              text = text.replaceAll('{{4}}', this.templates.new.body.examples[3]);
            }
          }
        }
      } else {
        text = this.templates.new.body.text.toString()
      }
      return text;
    },
    button_validate() {
      if (this.type_button === 0 && this.templates.new.buttons.length >= 2) {
        return false
      } else return !(this.type_button === 1 && this.templates.new.buttons.length >= 3);
    },
    validateFileHeader() {
      let isValid = true;

      if(this.templates.new.options.header && this.templates.new.header.format !== 'TEXT' && (!this.templates.new.header_file.file || this.templates.new.header_file.file === null || this.templates.new.header_file.file === '')) {
        return false
      } else {
        return true
      }

      return isValid;
    },
    validateVarsHeader() {
      let isValid = true;
      if (this.variable_header > 0) {
        if (this.templates.new.header.examples[0] === '' ||
          this.templates.new.header.examples[0] === null ||
          this.templates.new.header.examples[0] === undefined) {

          isValid = false;

        } else {
          isValid = true;
        }
      } else {
        isValid = true;
      }
      return isValid;
    },
    validateVarsBody() {
      let isValid = true;
      if (this.variable_body > 0) {
        if (this.variable_body !== this.templates.new.body.examples.length) {
          this.templates.new.body.examples = [];
          for (let i = 0; i < this.variable_body; i++) {
              this.templates.new.body.examples[i] = '';
          }
        }
        for (let i = 0; i < this.variable_body; i++) {
          if(this.templates.new.body.examples[i] === '') {
            isValid = false;
          }
        }
      } else {
        isValid = true;
      }
      return isValid;
    },
    validateVarsButtons() {
      let isValid = true;
      if (this.variable_button_url > 0) {
        if (this.variable_button_url_var === '' ||
          this.variable_button_url_var === null ||
          this.variable_button_url_var === undefined) {
          isValid = false;
        } else {
          isValid = true;
        }
      } else {
        isValid = true;
      }
      return isValid;
    },
  },
  data() {
    return {
      no_pic: no_pic,
      variable_header: 0,
      variable_body: 0,
      variable_button_url: 0,
      variable_button_url_var: null,
      index_button_url: null,
      type_button: null,
      type_button_cta: null,
      isShowEmoji: null,
      startPosition: null,
      endPosition: null,
      i18n: {
        search: 'Pesquisar...',
        categories: {
          Activity: "Atividades",
          Flags: "Bandeiras",
          Foods: "Comida",
          Frequently: "Frequentes",
          Objects: "Objetos",
          Nature: "Natureza",
          Peoples: "Pessoas",
          Symbols: "Símbolos",
          Places: "Locais"
        }
      },
      go_save: false
    }
  },
  mounted() {
    $('#addTemplateModal').on('hidden.bs.modal', () => {
      this.clearTemplate()
    })
  },
  watch: {
    'templates.new.header.content': function () {
      if (this.templates.new.header.content && this.templates.new.header.content.includes('{{1}}')) {
        this.variable_header = 1
      } else {
        this.variable_header = 0
      }
    },
    'variable_button_url': function () {
      if (this.variable_button_url > 0) {
        this.templates.new.buttons.forEach((button) => {
          if (button.type === 'URL') {
            this.variable_button_url_var = this.xeroxHelper(button.example[0])
          }
        });
      }
    },
    'variable_button_url_var': function () {
      if (this.variable_button_url_var) {
        this.templates.new.buttons.forEach((button, index) => {
          if (button.type === 'URL') {
            this.templates.new.buttons[index].example[0] = this.xeroxHelper(this.variable_button_url_var)
          }
        });
      }
    },
    'templates.new.body.text': function () {
      if (this.templates.new.body.text.includes('{{1}}')) {
        if (this.templates.new.body.text.includes('{{2}}')) {
          if (this.templates.new.body.text.includes('{{3}}')) {
            if (this.templates.new.body.text.includes('{{4}}')) {
              this.variable_body = 4
            } else {
              this.variable_body = 3
            }
          } else {
            this.variable_body = 2
          }
        } else {
          this.variable_body = 1
        }
      } else {
        this.variable_body = 0
      }
    }
  },
  methods: {
    setStep(payload) {
      this.$store.commit('SET_STEP', parseInt(payload))
    },
    clear() {
      const files = document.getElementById('fileHandlerHSM')
      if (files) {
        files.value = ''
      }
      this.templates.new.header_file = {
        text: '',
        file: null,
        mimetype: null,
        filename: null
      };
      this.templates.new.header.content = ""
    },
    showEmoji(payload) {
      if (payload === this.isShowEmoji) {
        this.isShowEmoji = null
      } else {
        this.isShowEmoji = payload
      }
    },
    selectEmoji(a) {
      this.startPosition = this.$refs[`input_${this.isShowEmoji}`].selectionStart;
      this.endPosition = this.$refs[`input_${this.isShowEmoji}`].selectionEnd;
      this.$refs[`input_${this.isShowEmoji}`].setSelectionRange(this.startPosition, this.endPosition);
      const text = this.$refs[`input_${this.isShowEmoji}`].value;
      if (text === null) {
        if (this.isShowEmoji === 1) {
          this.templates.new.header.content = a.data;
        }
        if (this.isShowEmoji === 2) {
          this.templates.new.body.text = a.data;
        }
        if (this.isShowEmoji === 3) {
          this.templates.new.footer.text = a.data;
        }
      } else {
        const textBefore = text.substring(0, this.startPosition);
        const textAfter = text.substring(this.endPosition, text.length);
        this.startPosition += a.data.length;

        if (this.isShowEmoji === 1) {
          this.templates.new.header.content = `${textBefore}${a.data}${textAfter}`;
        }
        if (this.isShowEmoji === 2) {
          this.templates.new.body.text = `${textBefore}${a.data}${textAfter}`;
        }
        if (this.isShowEmoji === 3) {
          this.templates.new.footer.text = `${textBefore}${a.data}${textAfter}`;
        }
      }
      setTimeout(() => {
        this.$refs[`input_${this.isShowEmoji}`].setSelectionRange(this.startPosition, this.startPosition);
        this.$refs[`input_${this.isShowEmoji}`].focus()
      }, 100)
    },
    loadFileHSM() {
      const files = document.getElementById('fileHandlerHSM')
      if (files.files && files.files[0]) {
        const file = files.files[0]

        // IMAGE
        if (this.templates.new.header.format === 'IMAGE') {
          if (['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
            const size = (file.size / 1024) / 1024
            if (size <= 5) {
              const FR = new FileReader();
              FR.addEventListener('load', (e) => {
                this.templates.new.header_file.file = e.target.result
                this.templates.new.header_file.mimetype = file.type
                this.templates.new.header_file.filename = file.name
              })
              FR.readAsDataURL(file)
            } else {
              Swal.fire(
                `${this.getTranslations('expression_683')}`,
                `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
                'warning'
              )
            }
          } else {
            Swal.fire(
              `${this.getTranslations('expression_683')}`,
              `${this.getTranslations('expression_684')} <br/> <small>${this.getTranslations('expression_892')}</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        }

        // DOCUMENT
        else if (this.templates.new.header.format === 'DOCUMENT') {
          if (['application/pdf'].includes(file.type)) {
            const size = (file.size / 1024) / 1024
            if (size <= 5) {
              const FR = new FileReader();
              FR.addEventListener('load', (e) => {
                this.templates.new.header_file.file = e.target.result
                this.templates.new.header_file.mimetype = file.type
                this.templates.new.header_file.filename = file.name
              })
              FR.readAsDataURL(file)
            } else {
              Swal.fire(
                `${this.getTranslations('expression_683')}`,
                `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
                'warning'
              )
            }
          } else {
            Swal.fire(
              `${this.getTranslations('expression_683')}`,
              `${this.getTranslations('expression_684')} <br/> <small>${this.getTranslations('expression_685')}</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        }
        // VIDEO
        else if (this.templates.new.header.format === 'VIDEO') {
          if (['video/mpeg', 'video/mp4'].includes(file.type)) {
            const size = (file.size / 1024) / 1024
            if (size <= 5) {
              const FR = new FileReader();
              FR.addEventListener('load', (e) => {
                this.templates.new.header_file.file = e.target.result
                this.templates.new.header_file.mimetype = file.type
                this.templates.new.header_file.filename = file.name
              })
              FR.readAsDataURL(file)
            } else {
              Swal.fire(
                `${this.getTranslations('expression_683')}`,
                `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
                'warning'
              )
            }
          } else {
            Swal.fire(
              `${this.getTranslations('expression_683')}`,
              `${this.getTranslations('expression_684')} <br/> <small>${this.getTranslations('expression_825')}</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
        }
      }
      $('#fileHandlerHSM').val('')
    },
    removeFileHSM() {
      this.templates.new.header_file.file = null
      this.templates.new.header_file.mimetype = null
      this.templates.new.header_file.filename = null
      $('#fileHandlerHSM').val('')
    },
    uploadFileHSM() {
      $('#fileHandlerHSM').click()
    },
    clearTemplate() {
      this.templates.step = 1
      const files = document.getElementById('fileHandlerHSM')
      if (files) {
        files.value = ''
      }
      this.templates.new = {
        header: {
          format: "TEXT",
          content: "",
          examples: []
        },
        body: {
          text: "",
          examples: []
        },
        footer: {
          text: ""
        },
        buttons: [],
        category: null,
        name: null,
        language: null,
        options: {
          header: false,
          body: true,
          footer: false,
          buttons: false,
        },
        header_file: {
          text: '',
          file: null,
          mimetype: null,
          filename: null
        }
      }
    },
    addTemplate() {
      this.templates.new.channel_id = window.localStorage.getItem("channel_id")
      this.$store.dispatch('addTemplate', this.templates.new)
    },
    addButton(payload) {
      if (payload === 0) {
        if (this.templates.new.buttons && this.templates.new.buttons[0]) {
          if (this.templates.new.buttons[0].type === 'PHONE_NUMBER') {
            this.templates.new.buttons.push({
              type: "URL",
              text: "",
              url: ""
            })
          } else {
            this.templates.new.buttons.push({
              type: "PHONE_NUMBER",
              text: "",
              phone_number: ""
            })
          }
        } else {
          this.templates.new.buttons.push({
            type: "PHONE_NUMBER",
            text: "",
            phone_number: ""
          })
        }
      } else if (payload === 1) {
        this.templates.new.buttons.push({
          type: "QUICK_REPLY",
          text: ""
        })
      }

    },
    removeButton(payload) {
      if (this.templates.new.buttons[payload].type === 'URL') {
        this.variable_button_url = 0
        this.index_button_url = null
        if (this.templates.new.buttons[payload].example !== undefined) {
          delete this.templates.new.buttons[payload].example;
        }
      }
      this.templates.new.buttons.splice(payload, 1)
      if (this.templates.new.buttons !== undefined && this.templates.new.buttons.length > 0) {
        this.templates.new.buttons.forEach((button, index) => {
          if (button.type === 'URL') {
            this.whatIsTheIndex(index);
          }
        });
      }
    },
    whatIsTheIndex(payload) {
      if (this.templates.new.buttons[payload].url && this.templates.new.buttons[payload].url.includes('{{1}}')) {
        this.variable_button_url = 1
        this.index_button_url = payload
        this.templates.new.buttons[payload].example = ['']
      } else {
        this.variable_button_url = 0
        this.index_button_url = null
        if (this.templates.new.buttons[payload].example !== undefined) {
          delete this.templates.new.buttons[payload].example;
        }
      }
    },
    changeButtonType(payload) {
      if (this.templates.new.buttons[payload].type === 'URL') {
        this.templates.new.buttons[payload] = {
          type: 'URL',
          text: '',
          url: ''
        }
      }
      if (this.templates.new.buttons[payload].type === 'PHONE_NUMBER') {
        this.templates.new.buttons[payload] = {
          type: 'PHONE_NUMBER',
          text: '',
          phone_number: ''
        }
      }
      if (this.templates.new.buttons[payload].type === 'QUICK_REPLY') {
        this.templates.new.buttons[payload] = {
          type: 'QUICK_REPLY',
          text: '',
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
